



































import Vue from 'vue'

import { GetCounselors, ActiveCounselings } from './AssignCounselor.graphql'
import { GetCounselorsQuery } from '@/graphql-schema'
import { CaseWithMessages } from '@/queries/cases.graphql'
import { runInThisContext } from 'vm'
import treatment from '@/routing/treatment'

export default Vue.extend({
  apollo: {
    counselors: {
      query: GetCounselors,
    },
    pickedCase: {
      query: CaseWithMessages,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          id: this.caseId,
        }
      },
    },
    allActiveCounselingsForCounselors: {
      query: ActiveCounselings,
      fetchPolicy: 'no-cache',
    },
  },
  data(): {
    counselorId: string | null
    counselors: GetCounselorsQuery['counselors']
    openModal: boolean
  } {
    return {
      counselorId: null,
      counselors: { nodes: [] },
      openModal: false,
    }
  },
  computed: {
    options(): any[] {
      const counselors = this.counselors?.nodes || []
      return counselors.map(t => ({ value: t.id, text: t.username }))
    },
    isCounselingListAvailable(): boolean {
      return this.allActiveCounselingsForCounselors?.nodes.length > 0 || false
    },
    activeCounselors(): any[] {
      if (this.allActiveCounselingsForCounselors) {
        return this.allActiveCounselingsForCounselors?.nodes || []
      }
      return []
    },
    interviewerName(): string {
      if (this.pickedCase?.members?.nodes.length > 0) {
        const member = this.pickedCase?.members?.nodes.find(
          actMember => actMember.actsAsInterviewer
        )
        return member.alias
      }
      return ''
    },
  },
  props: {
    value: {
      required: true,
      type: Object,
    },
    caseId: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.openModal = true
  },
})
